import { __awaiter, __generator, __spreadArray } from '../../node_modules/tslib/tslib.es6.js';
import { WIDGET_SPACE, TABLET_SCREEN_SIZE, WIDGET_SPACE_HALF, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING } from '../../utils/constants/Constants.js';
import { styled, Grid } from '@mui/material';
import React, { useState, useEffect } from 'react';
import BrandclubProductGrid from '../components/BrandclubProudctGrid/index.js';
import { GenericContainer } from '../components/GenericContainer.js';
import '../../api/graphQl/brand.js';
import { ProductOperation, UNAUTHENTICATED_SEARCH_PRODUCTS } from '../../api/graphQl/product.js';

var _a;
var CuratedProductsContainer = styled(GenericContainer)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: WIDGET_SPACE,
            paddingBottom: WIDGET_SPACE,
            paddingLeft: '5%',
            paddingRight: '5%',
            boxSizing: 'border-box',
            color: theme.palette.primary.main
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(0, "px"),
        },
        _b);
});
var ContentWrapper = styled(Grid)((_a = {
        maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
        width: '100%'
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {},
    _a));
var CuratedProducts = function (_a) {
    var title = _a.title, products = _a.products, LinkComponent = _a.LinkComponent, apolloClient = _a.apolloClient, pageContext = _a.pageContext, onShareClick = _a.onShareClick;
    var filteredProducts = products.filter(function (sku) { return !['Add products'].includes(sku); });
    var _b = useState([]), popularProducts = _b[0], setPopularProducts = _b[1];
    useEffect(function () {
        if (apolloClient && filteredProducts && filteredProducts.length > 0) {
            var fetchProducts = function () { return __awaiter(void 0, void 0, void 0, function () {
                var treatment, data, productResult, sortedProductResult;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            treatment = (pageContext === null || pageContext === void 0 ? void 0 : pageContext.abTestingTreatments) && (pageContext === null || pageContext === void 0 ? void 0 : pageContext.abTestingTreatments.searchImprovementTreatment)
                                ? {
                                    search: pageContext === null || pageContext === void 0 ? void 0 : pageContext.abTestingTreatments.searchImprovementTreatment,
                                }
                                : undefined;
                            return [4 /*yield*/, apolloClient.query({
                                    query: UNAUTHENTICATED_SEARCH_PRODUCTS,
                                    variables: {
                                        titleInclude: filteredProducts,
                                        sort: [],
                                        page: {
                                            start: 0,
                                            size: filteredProducts.length,
                                        },
                                        computeFacets: true,
                                        treatment: treatment,
                                    },
                                })];
                        case 1:
                            data = (_c.sent()).data;
                            productResult = (_b = (_a = data === null || data === void 0 ? void 0 : data[ProductOperation.UnauthenticatedSearch]) === null || _a === void 0 ? void 0 : _a.products) !== null && _b !== void 0 ? _b : [];
                            sortedProductResult = __spreadArray([], productResult, true).sort(function (a, b) {
                                var aIndex = filteredProducts.indexOf(a.stacklineSku);
                                var bIndex = filteredProducts.indexOf(b.stacklineSku);
                                if (aIndex === -1 || bIndex === -1)
                                    return -1;
                                return aIndex < bIndex ? -1 : 1;
                            });
                            setPopularProducts(sortedProductResult);
                            return [2 /*return*/];
                    }
                });
            }); };
            fetchProducts();
        }
        else {
            setPopularProducts([]);
        }
    }, [products, apolloClient]);
    return (React.createElement(CuratedProductsContainer, null,
        React.createElement(ContentWrapper, null,
            React.createElement(BrandclubProductGrid, { onShareClick: onShareClick, LinkComponent: LinkComponent, title: title, products: popularProducts }))));
};

export { CuratedProducts };
//# sourceMappingURL=index.js.map
